/* eslint-disable react/jsx-closing-bracket-location */
import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import NotificationService from '../../../../Service/NotificationService';
import TextField from '@material-ui/core/TextField';
import PageHeader from '../../../Common/PageHeader';
import CircularProgress from '@material-ui/core/CircularProgress';
import Swal from 'sweetalert2';
import EditIcon from '@material-ui/icons/Edit';
class UpdateSms extends Component {
	constructor(props) {
		super(props);
		this.state = {
			key: '',
			locale: '',
			template: '',
			template_name: '',
			isLoading: false,
			isSaved: false
		};
	}

	handleOnChange = event => {
		console.log(event.target.value);
		this.setState({
			template: event.target.value
		});
	};

	updateSms = async () => {
		const requestBody = {
			locale: this.state.locale,
			template: this.state.template,
			key: this.state.key,
			template_name: this.state.template_name
		};
		this.setState({ isSaved: true });
		await NotificationService.updateSmsTemplate(this.props.match.params.id, requestBody);
		await this.fetchSms();
	};

	fetchSms = async () => {
		this.setState({ isLoading: true, isSaved: false });
		const resp = await NotificationService.getOneSmsTemplates(
			this.props.match.params.id,
			this.props.match.params.key,
			this.props.match.params.locale
		);
		this.setState({
			key: resp.key,
			locale: resp.locale,
			template: resp.template,
			template_name: resp.template_name,
			isLoading: false
		});
	};

	updateSubjectOrTemplateName() {
		Swal.fire({
			title: 'Edit Template Name',
			input: 'text',
			inputValue: this.state.template_name,
			showCancelButton: true,
			confirmButtonText: 'Update',
			showLoaderOnConfirm: true,
			confirmButtonColor: '#3085d6',
			cancelButtonColor: '#d33',
			
			customClass: 'otp_message_success'
		}).then(result => {
			if (result.value) {
				this.setState({ template_name: result.value });
			}
		});
	}

	componentDidMount() {
		this.fetchSms();
	}

	render() {
		if (this.state.isLoading) {
			return 'Loading...';
		}
		return (
			<>
				<PageHeader text={`SMS Template - ${this.state.template_name}`}>
					<div className="col-sm-2">
						<EditIcon
							style={{ cursor: 'pointer', marginTop: '5px' }}
							onClick={() => {
								this.updateSubjectOrTemplateName();
							}}>
							Edit Name
						</EditIcon>
					</div>
				</PageHeader>
				<div className="card card-outline card-primary">
					<div className="card-body">
						<TextField
							id="outlined-multiline-static"
							label="Sms Template"
							multiline
							onChange={this.handleOnChange}
							rows={4}
							value={this.state.template}
							variant="outlined"
						/>
					</div>
				</div>
				<button
					className="btn btn-block btn-success"
					onClick={this.updateSms}
					style={{ width: '15%', marginLeft: '40%' }}
					type="button">
					Save
					{this.state.isSaved ? <CircularProgress disableShrink size={18} style={{ color: 'white' }} /> : ''}
				</button>
				<br />
				<Link to={`/admin/tenant/sms-templates/${this.props.match.params.id}`}>
					<button
						className="btn btn-block btn-primary"
						style={{ width: '15%', marginLeft: '40%' }}
						type="button">
						Back
					</button>
				</Link>
			</>
		);
	}
}

export default withRouter(UpdateSms);
